import { combineEpics } from 'redux-observable';
import { loginEpic } from './dashboardEpic';
import { genericEpic } from './genericEpic';

const rootEpic = combineEpics(
  loginEpic,
  genericEpic,
);

export default rootEpic;